import React from "react";
import "./ThicknessPicker.sass";

/** Line widths of PO (po-chart-visual-spec.md §5.4, §7.2): 1px…5px. */
export const DEFAULT_THICKNESS_OPTIONS = [1, 2, 3, 4, 5];

const formatPixels = (width) => `${width}px`;

/**
 * Line width buttons «1px … 5px», one of them selected: the line style of
 * indicators (TV-17) and drawings (TV-19, TV-20). The look and the number of
 * columns come from CSS custom properties (ThicknessPicker.sass), so the
 * same picker fits a popover row or a 3 + 2 grid.
 *
 * @param {object}   props
 * @param {number}   props.value - selected width
 * @param {(width: number) => void} props.onChange
 * @param {string}   props.label - accessible name of the group, e.g. "Line width"
 * @param {number[]} [props.options] - widths in the order of the buttons
 * @param {(width: number) => string} [props.formatOption] - button text
 */
const ThicknessPicker = ({
  value,
  onChange,
  label,
  options = DEFAULT_THICKNESS_OPTIONS,
  formatOption = formatPixels,
}) => (
  <div className="thickness-picker" role="radiogroup" aria-label={label}>
    {options.map((width) => {
      const isSelected = width === value;

      return (
        <button
          key={width}
          type="button"
          role="radio"
          aria-checked={isSelected}
          className={`thickness-picker__option${isSelected ? " thickness-picker__option--selected" : ""}`}
          onClick={() => onChange(width)}
        >
          {formatOption(width)}
        </button>
      );
    })}
  </div>
);

export default ThicknessPicker;
